import script from "./SummaryRadioGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./SummaryRadioGroup.vue?vue&type=script&setup=true&lang=ts"

import "./SummaryRadioGroup.vue?vue&type=style&index=0&id=c63cbe22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c63cbe22"]])

export default __exports__